import api, { V2_ADMIN_PREFIX } from '@/apis/api';
import { Partner, PartnerListItem } from '@/types/partners';
import { useQuery } from '@tanstack/react-query';

export const PARTNER_SEARCH_QUERY_KEY = 'partner_search';

export const usePartnerSearchQuery = (debouncedSearchQuery: string) => {
  const trimmed = debouncedSearchQuery.trim();

  const { data, isLoading } = useQuery({
    queryKey: [PARTNER_SEARCH_QUERY_KEY, trimmed],
    queryFn: async () => {
      if (!trimmed) return { items: [] as Partner[] };
      const { data: res } = await api.get<PartnerListItem[]>(`${V2_ADMIN_PREFIX}/partners`, {
        params: { search_query: trimmed },
      });
      const items: Partner[] = (res || []).map(p => ({
        id: p.id,
        name: p.name ?? '',
      }));
      return { items };
    },
    enabled: trimmed.length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    partners: data?.items ?? [],
    isLoading,
  };
};
